import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import { useModal, useModalUpdate, useModalContent }  from "../context/ModalContext";
// import { useModalScroll, useModalContent }  from "../context/MixContext";
// import { useData } from "../../components/context/DataContext";

// import { renderFormattedText } from "../../utils/helpers";
import ModalContent from '../ModalContent/ModalContent';

import './PopupModal.css'


const PopupModal = () => {

    const modalState = useModal(true);
    const setModalState = useModalUpdate();
    const ModalItems = useModalContent();
    const [isVisible, setIsVisible] = useState(false);

    Modal.setAppElement('#root')

    const customStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 40,
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(0, 0, 37, .8)',
          zIndex: 1000
        },
        content : {
          position: 'relative',
          background: '#002F55',
          inset: 0,
          margin: 20,
          overflow: 'unset',
          border: "none",
          borderTopRightRadius: 4
        }
      };


      function closeModal(){
        setModalState(false);
        setIsVisible(false);
      }

      function afterOpenModal(){
        // 
      }

      function afterClose(){
        // 
      }

    return (
      <Modal
            closeTimeoutMS={0}
            isOpen={ modalState }
            onAfterOpen={afterOpenModal}
            onAfterClose={afterClose}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Quiz Modal"
            id="react-modal"
            >             
                <ModalContent close={closeModal} />     
        </Modal>
    );
};


export default PopupModal;